import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
    return ApiCaller('/v1/admin/playlists/copy', 'POST', payload);
};

export default function* watchRequest() {
    yield takeLatest('DUPLICATE_CUSTOMER_PLAYLIST', function* performAction(action) {
        yield put({ type: 'DUPLICATE_CUSTOMER_PLAYLIST_INITIATED' });
        try {
            const data = yield call(callAPI.bind(this, action.payload));
            yield put({ type: 'DUPLICATE_CUSTOMER_PLAYLIST_SUCCESS', payload: data });
        } catch (error) {
            yield put({ type: 'DUPLICATE_CUSTOMER_PLAYLIST_FAILED', payload: error });
        }
    });
}